import axios from "../../axios";
import React, { useState } from "react";
import { toast } from "react-toastify";
import { IP } from "../../internalServer";
import { Delete, Trash2 } from "lucide-react";
import assets from "../../assets/assets";
import { iconData } from "../../iconData";
import PdfViewer from "./PdfViewer";

const CreateMcq = ({ nextQuestion, question, setQuestions }) => {
  const { options, correct_answers } = question;

  const [isValidFileType, setIsValidFileType] = React.useState(true);
  const [fLimit, setFLimit] = React.useState(false);
  const [loadingOptionIndex, setLoadingOptionIndex] = useState(null);
  const [zoomedImage, setZoomedImage] = useState(null);
  const [fileIndex, setFileIndex] = useState(null);

  const [mideaviewer, setMideaviewer] = useState(false);
  const [responseAttach, setResponseAttach] = useState("");

  let teacher_id = JSON.parse(localStorage.getItem("Teacher_id"));

  const addOptions = () => {
    setQuestions((prev) => {
      const updatedOptions = [
        ...prev[nextQuestion].options,
        {
          key: String.fromCharCode(prev[nextQuestion].options.length + 65),
          value: null,
          attachment: null,
        },
      ];

      const updatedQuestion = {
        ...prev[nextQuestion],
        options: updatedOptions,
        is_question_edited: true,
      };

      const newQuestions = [...prev];
      newQuestions[nextQuestion] = updatedQuestion;

      return newQuestions;
    });
  };

  const removeOptions = (index) => {
    setQuestions((prev) => {
      const currentQuestion = prev[nextQuestion];
      const updatedOptions = currentQuestion.options
        .filter((_, idx) => idx !== index)
        .map((option, i) => ({
          ...option,
          key: String.fromCharCode(65 + i),
        }));

      const removedOptionKey = currentQuestion.options[index]?.key;

      const updatedCorrectAnswer = currentQuestion.correct_answers.map((ans) =>
        ans.option_key === removedOptionKey ? { ...ans, value: null } : ans,
      );

      const updatedQuestion = {
        ...currentQuestion,
        options: updatedOptions,
        correct_answers: updatedCorrectAnswer,
        is_question_edited: true,
      };

      const newQuestions = [...prev];
      newQuestions[nextQuestion] = updatedQuestion;

      return newQuestions;
    });
  };

  const handleOptionChange = (index, value) => {
    setQuestions((prev) => {
      const updatedOptions = prev[nextQuestion].options.map((opt, i) =>
        i === index ? { ...opt, value } : opt,
      );

      const updatedQuestion = {
        ...prev[nextQuestion],
        options: updatedOptions,
        is_question_edited: true,
      };

      const newQuestions = [...prev];
      newQuestions[nextQuestion] = updatedQuestion;

      return newQuestions;
    });
  };

  const validateFileType = (filePath) => {
    var allowedExtensions = /(\.jpg|\.jpeg|\.png)$/i;

    if (
      !allowedExtensions.exec(filePath.name) ||
      question?.attachments?.length > 5
    ) {
      setIsValidFileType(false);
      return false;
    }
    setIsValidFileType(true);
    return true;
  };

  const handleAttachment = async (file, optionIndex) => {
    if (!file || file.length === 0) return;

    const maxSize = 10 * 1024 * 1024; // 10MB

    console.log(file, "file");

    setFileIndex(optionIndex);

    if (file.size > maxSize) {
      setFLimit(true);
      return;
    }

    try {
      setLoadingOptionIndex(optionIndex);
      const formData = new FormData();
      formData.append("name", file.name);
      formData.append("uploadQuestionAttachment", file);

      const res = await axios.post(
        `/api/v1/question/uploadAttachment/teacherId/${teacher_id}`,
        formData,
      );
      console.log(res, "res");
      console.log(res?.data?.data);
      console.log(file, "file");
      if (res?.data?.data) {
        const attachmentUrl = res.data.data;
        const attachmentSizeKb = Math.round(file.size / 1024);

        // update that specific option
        setQuestions((prev) => {
          const updated = [...prev];
          const updatedOptions = [...updated[nextQuestion].options];

          updatedOptions[optionIndex] = {
            ...updatedOptions[optionIndex],
            attachment: attachmentUrl,
            attachment_sizeKb: attachmentSizeKb,
          };

          updated[nextQuestion] = {
            ...updated[nextQuestion],
            is_question_edited: true,
            options: updatedOptions,
          };

          return updated;
        });

        setFLimit(false);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoadingOptionIndex(null);
    }
  };

  const checkRemoveAttachmentisFromLibrary = (idx, attachment) => {
    if (question.id) {
      handleSoftDeleteAttachment(idx, attachment);
    } else {
      handleRemoveAttachment(idx, attachment);
    }
  };

  const handleSoftDeleteAttachment = (idx, attachment) => {
    setQuestions((prev) => {
      const updatedOptions = prev[nextQuestion].options.map((opt, i) =>
        i === idx ? { ...opt, attachment: null, attachment_sizeKb: null } : opt,
      );

      const updatedQuestion = {
        ...prev[nextQuestion],
        options: updatedOptions,
        is_question_edited: true,
      };

      const newQuestions = [...prev];
      newQuestions[nextQuestion] = updatedQuestion;

      return newQuestions;
    });
  };

  const handleRemoveAttachment = async (optionIndex, attachmentPath) => {
    try {
      const res = await axios.delete(`/api/v1/file/delete`, {
        data: { file_path: attachmentPath },
      });

      if (res) {
        setQuestions((prev) => {
          const updatedOptions = prev[nextQuestion].options.map((opt, i) =>
            i === optionIndex
              ? { ...opt, attachment: null, attachment_sizeKb: null }
              : opt,
          );

          const updatedQuestion = {
            ...prev[nextQuestion],
            options: updatedOptions,
            is_question_edited: true,
          };

          const newQuestions = [...prev];
          newQuestions[nextQuestion] = updatedQuestion;

          return newQuestions;
        });
      }
    } catch (error) {
      console.error("Failed to delete attachment:", error);
    }
  };

  const addMoreCorrectAnswers = () => {
    setQuestions((prev) => {
      const updatedCorrectAnswer = [
        ...prev[nextQuestion].correct_answers,
        {
          option_key: null,
          value: null,
          reason_for_answer: { explanation: null },
        },
      ];

      const updatedQuestion = {
        ...prev[nextQuestion],
        correct_answers: updatedCorrectAnswer,
        is_question_edited: true,
      };

      const newQuestion = [...prev];
      newQuestion[nextQuestion] = updatedQuestion;
      return newQuestion;
    });
  };

  const removeMoreCorrectAnswers = (index) => {
    setQuestions((prev) => {
      const updatedCorrectAnswer = prev[nextQuestion].correct_answers
        .filter((_, idx) => idx !== index)
        .map((cAnswers) => ({
          ...cAnswers,
          reason_for_answer: {
            explanation: cAnswers.reason_for_answer.explanation,
          },
        }));

      const updatedQuestion = {
        ...prev[nextQuestion],
        correct_answers: updatedCorrectAnswer,
        is_question_edited: true,
      };

      const newQuestions = [...prev];
      newQuestions[nextQuestion] = updatedQuestion;
      return newQuestions;
    });
  };

  const handleCorrectAnswerChange = (index, value) => {
    setQuestions((prev) => {
      const optionValue = prev[nextQuestion].options.find(
        (opt) => opt.key === value,
      )?.value;

      const updatedCorrectAnswer = prev[nextQuestion].correct_answers.map(
        (ans, i) =>
          i === index
            ? {
                ...ans,
                option_key: value,
                value: optionValue,
              }
            : ans,
      );

      const updatedQuestion = {
        ...prev[nextQuestion],
        correct_answers: updatedCorrectAnswer,
        is_question_edited: true,
      };

      const newQuestions = [...prev];
      newQuestions[nextQuestion] = updatedQuestion;

      return newQuestions;
    });
  };

  const handleReasonChange = (index, value) => {
    setQuestions((prev) => {
      const updatedCorrectAnswer = prev[nextQuestion].correct_answers.map(
        (ans, i) =>
          i === index
            ? { ...ans, reason_for_answer: { explanation: value } }
            : ans,
      );

      const updatedQuestion = {
        ...prev[nextQuestion],
        correct_answers: updatedCorrectAnswer,
        is_question_edited: true,
      };

      const newQuestions = [...prev];
      newQuestions[nextQuestion] = updatedQuestion;
      return newQuestions;
    });
  };

  const handleClickforpdf = (fileUrl) => {
    setResponseAttach(fileUrl);
    setMideaviewer(true);
  };

  return (
    <>
      {options?.map((option, index) => (
        <div
          key={index}
          className="d-flex mb-3 mt-3 me-5 hw_mcq_option_box_width align-items-center justify-content-center"
        >
          <div className="d-flex flex-column w-100 gap-1">
            <span className="poppins-semibold me-2">Option {option.key}</span>
            <div className="d-flex flex-row align-items-center">
              <textarea
                className="hw_mcq_option_box w-100"
                rows="1"
                placeholder={`option - ${option.key.toLowerCase()}`}
                value={option.value}
                onChange={(e) => handleOptionChange(index, e.target.value)}
                style={{ width: "100%" }}
                cols={5}
              />
              <div className="d-flex flex-row gap-2 align-items-center justify-content-center ms-2">
                {!option.attachment && (
                  <>
                    <input
                      type="file"
                      id={`attachOption${nextQuestion}-${index}`}
                      style={{ display: "none" }}
                      accept=".pdf,.jpg,.jpeg,.png"
                      onChange={(e) =>
                        handleAttachment(e.target.files[0], index)
                      }
                    />

                    <label
                      htmlFor={`attachOption${nextQuestion}-${index}`}
                      style={{
                        border: "1px solid #8D4B28",
                        color: "#8D4B28",
                        backgroundColor: "white",
                      }}
                      className="rounded-3 p-1 d-flex align-items-center justify-content-center poppins-semibold mt-2"
                    >
                      <img
                        src={assets.UploadIcon}
                        height="100%"
                        width="25px"
                        alt="Attach Icon"
                        style={{
                          objectFit: "contain", // ensures proper scaling
                          maxHeight: "100%", // keep it within label height
                        }}
                      />
                    </label>
                  </>
                )}

                {loadingOptionIndex === index && (
                  <img
                    style={{ width: "32px", height: "32px" }}
                    src="/gif/Loader.gif"
                    alt="Loading"
                  />
                )}

                <span style={{ color: "red", width: "100%", fontSize: "10px" }}>
                  {fLimit && index === fileIndex && "Max file size: 10 MB "}
                </span>

                {option.attachment &&
                  (() => {
                    const fileUrl =
                      typeof option.attachment === "string"
                        ? option.attachment
                        : option.attachment?.url;

                    if (!fileUrl) return null;

                    const fileType = fileUrl.split(".").pop().toLowerCase();
                    const isImage = ["jpg", "jpeg", "png"].includes(fileType);
                    const isVideo = ["mp4", "mov"].includes(fileType);
                    const isPdf = fileType === "pdf";

                    const fileIcon =
                      iconData?.find((i) => i.extension === fileType)?.icon ||
                      "/images/file_icon.png";

                    const fullUrl = fileUrl.startsWith("http")
                      ? fileUrl
                      : `${IP}${fileUrl}`;

                    return (
                      <div className="d-flex flex-row align-items-center me-3">
                        {/* ===== Preview ===== */}
                        {isImage ? (
                          <img
                            src={fullUrl}
                            alt="attachment"
                            onClick={() => setZoomedImage(fullUrl)}
                            style={{
                              width: "60px",
                              height: "50px",
                              objectFit: "cover",
                              borderRadius: "6px",
                              marginBottom: "5px",
                              cursor: "pointer",
                            }}
                          />
                        ) : isVideo ? (
                          <video
                            src={fullUrl}
                            style={{
                              width: "60px",
                              height: "50px",
                              borderRadius: "6px",
                              marginBottom: "5px",
                            }}
                            controls
                          />
                        ) : isPdf ? (
                          <div
                            onClick={() => handleClickforpdf(fileUrl)}
                            style={{
                              width: "100px",
                              height: "50px",
                              background: "#f5f5f5",
                              borderRadius: "6px",
                              cursor: "pointer",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <img
                              src={fileIcon}
                              alt="pdf"
                              style={{ width: "24px", height: "24px" }}
                            />
                            <div className="hw_default_attach_name">
                              <span>
                                {option.attachment?.replace(/^[^_]*_/, "")}
                              </span>
                            </div>
                          </div>
                        ) : (
                          <a
                            href={`https://docs.google.com/gview?url=${encodeURIComponent(
                              fullUrl,
                            )}&embedded=true`}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ textDecoration: "none" }}
                          >
                            <div
                              style={{
                                width: "100px",
                                height: "50px",
                                background: "#f5f5f5",
                                borderRadius: "6px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <img
                                src={fileIcon}
                                alt="file"
                                style={{ width: "24px", height: "24px" }}
                              />
                            </div>
                          </a>
                        )}

                        {/* ===== Remove Button ===== */}
                        <img
                          onClick={() =>
                            checkRemoveAttachmentisFromLibrary(
                              index,
                              option.attachment,
                            )
                          }
                          className="attachment_cross_icon align-self-start"
                          src="/images/attachment_cross_icon.png"
                          alt="Remove"
                          style={{
                            cursor: "pointer",
                            width: "14px",
                            height: "14px",
                            marginLeft: "8px",
                          }}
                        />
                      </div>
                    );
                  })()}

                {options.length > 1 && (
                  <div
                    style={{
                      border: "1px solid #8D4B28",
                      color: "#8D4B28",
                      backgroundColor: "white",
                    }}
                    className="rounded-3 p-1 d-flex align-items-center justify-content-center poppins-semibold"
                  >
                    <Trash2 size={20} onClick={() => removeOptions(index)} />
                    {/* <img
                  onClick={() => removeOptions(index)}
                  src="/images/Dustbin.svg"
                  alt="Delete option"
                  className="hw_delet_option_icon mb-3"
                /> */}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      ))}

      <div className="d-grid gap-2 d-md-flex justify-content-md-center">
        <button
          onClick={addOptions}
          style={{
            border: "2px solid #8D4B28",
            color: "#8D4B28",
            backgroundColor: "white",
          }}
          className="rounded-3 px-3 py-1 d-flex align-items-center justify-content-center poppins-semibold"
          type="button"
        >
          <img src="/images/add button.svg" className="mx-1" alt="" />
          Add more options
        </button>
      </div>

      <div className="ml-1 mb-3 col-12">
        <div className="hw_select_ans ml-1 mb-2 poppins-semibold">
          Select the correct answer<span style={{ color: "red" }}>*</span>
        </div>
        {correct_answers?.map((cOption, index) => (
          <div key={index} className="mb-3 col-12 p-0">
            <div className="w-100">
              <div className="d-flex">
                <div className="hw_mcq_answer_option_box">
                  <div
                    className="col-2 p-0 m-0 hw_select_option_dropdown_size"
                    style={{ width: "90px" }}
                  >
                    <select
                      onChange={(e) =>
                        handleCorrectAnswerChange(index, e.target.value)
                      }
                      value={cOption.option_key}
                      className="form-select select_option_dropdown py-1"
                    >
                      <option value="">Option</option>
                      {options.map((option, i) => (
                        <option key={i} value={option.key}>
                          {option.key}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-10 hw_correct_ans_option">
                    {cOption.value}
                  </div>
                </div>

                <div
                  style={{
                    border: "1px solid #8D4B28",
                    color: "#8D4B28",
                    backgroundColor: "white",
                  }}
                  className="rounded-3 ms-2 p-1 d-flex align-items-center justify-content-center poppins-semibold"
                >
                  <Trash2
                    size={20}
                    onClick={() => removeMoreCorrectAnswers(index)}
                  />
                  {/* <img
                  onClick={() => removeOptions(index)}
                  src="/images/Dustbin.svg"
                  alt="Delete option"
                  className="hw_delet_option_icon mb-3"
                /> */}
                </div>
              </div>

              <div className=" ml-1 mt-3 poppins-semibold">
                Add reason for correct answer
              </div>
              <input
                onChange={(e) => handleReasonChange(index, e.target.value)}
                className="hw_mcq_option_box mt-2"
                style={{ width: "100%" }}
                placeholder="reason for answer"
                value={cOption.reason_for_answer.explanation}
              />
            </div>
          </div>
        ))}
      </div>

      <div className="d-grid gap-2 d-md-flex justify-content-md-center mb-2">
        <button
          onClick={addMoreCorrectAnswers}
          style={{
            border: "2px solid #8D4B28",
            color: "#8D4B28",
            backgroundColor: "white",
          }}
          className="rounded-3 px-3 py-1 d-flex align-items-center justify-content-center poppins-semibold"
          type="button"
        >
          <img src="images/add button.svg" alt="" className="mx-1" />
          Add more correct answers
        </button>
      </div>
      {mideaviewer && (
        <PdfViewer
          setMideaviewer={setMideaviewer}
          attachment={responseAttach}
        />
      )}

      {zoomedImage && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0, 0, 0, 0.85)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          {/* Close button */}
          <button
            onClick={() => setZoomedImage(null)}
            style={{
              position: "absolute",
              top: "20px",
              right: "30px",
              background: "transparent",
              border: "none",
              fontSize: "2rem",
              color: "white",
              cursor: "pointer",
              zIndex: 10000,
            }}
            aria-label="Close"
          >
            &times;
          </button>

          {/* Zoomed image */}
          <img
            src={zoomedImage}
            alt="Zoomed"
            style={{
              maxWidth: "90%",
              maxHeight: "90%",
              borderRadius: "8px",
              boxShadow: "0 0 10px #000",
            }}
          />
        </div>
      )}
    </>
  );
};

export default CreateMcq;
